import { BarcodeInput } from "@/components/molecule/barcodeInput/BarcodeInput";
import { useModal } from "@/context/ModalStackManager";
import { Flex } from "@mantine/core";
import { useNavigate } from "react-router-dom";

const WorkTransfer = Object.assign(
  {},
  {
    BarcodeInput: BarcodeInput,
    Flex: Flex,
  }
);

export const WorkTransferForm = () => {
  const navigate = useNavigate();
  const { closeModal } = useModal();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      navigate(`/work/${e.currentTarget.value}`);
      closeModal();
    }
  };
  return (
    <WorkTransfer.Flex>
      <WorkTransfer.BarcodeInput onKeyDown={handleKeyDown} />
    </WorkTransfer.Flex>
  );
};
